import { createSelector } from 'reselect'
import isLoadedCartSelect from 'modules/cart/redux/selectors/is-loaded'
import getItemIdToSummaryCartSelect from 'modules/cart/redux/selectors/get-item-id-to-summary'
import hasInfoCartSelect from 'modules/cart/redux/selectors/has-info'
import { isReadyCartSelectUtil } from 'modules/cart/redux/selectors/is-ready/utils'

export const isReadyCartSelect = createSelector(
  isLoadedCartSelect,
  hasInfoCartSelect,
  getItemIdToSummaryCartSelect,
  (
    isLoaded,
    hasCartInfo,
    itemIdToSummary
  ) => isReadyCartSelectUtil({
    isLoaded,
    hasCartInfo,
    itemIdToSummary
  })
)
